module.exports = __webpack_public_path__ + "2b9b4872cd25494093c1eb14f0264a0b.svg";